import React from 'react';
import {useState,useContext} from "react";
import './Register.css';
import registerWithEmailAndPassword from '../helpers/firebase';
import Modal from './Modal';
import FormState from '../context/FormState';
import LoadingScreen from './LoadingScreen';
import { Link } from 'react-router-dom';

import { Icon } from 'react-icons-kit'
import {eye} from 'react-icons-kit/feather/eye'
import {eyeOff} from 'react-icons-kit/feather/eyeOff'
import Header from '../../../common_components/Header';
import ConnectWithUs from '../../../common_components/ConnectWithUs';
import Footer from '../../../common_components/Footer';

function Register(props) {
        const [email,setEmail]=useState("");
        const [password,setPassword]=useState("");
        const [name,setName]=useState("");
        const [error,setError]=useState("");
        const [showModal,setShowModal]=useState(false);
        const [isLoading,setIsLoading]=useState(false);

        const [confirmPassword, setConfirmPassword] = useState("")

        // Confirm Password toggle icon
        const [type, setType]=useState('password');
        const [icon, setIcon]=useState(eyeOff);

        const handleToggle=()=>{    
            if(type==='password'){
            setIcon(eye);      
            setType('text');
            }
            else{
            setIcon(eyeOff);     
            setType('password');
            }
        }

        // Password toggle icon
        const [typee, setTypee]=useState('password');
        const [iconn, setIconn]=useState(eyeOff);

        const handleTogglee =()=>{    
            if(typee==='password'){
                setIconn(eye);      
            setTypee('text');
            }
            else{
            setIconn(eyeOff);     
            setTypee('password');
            }
        }

        const ctx=useContext(FormState);
        const handleSubmit =  async(event)=>{
            event.preventDefault();
            if((!password.match(/[a-z]/g) || !password.match(/[A-Z]/g) || !password.match(/[0-9]/g) || !password.match(
                /[^a-zA-Z\d]/g) || !password.length >= 8))setError("Password must contain atleast 8 chars with digits and symbols.");
                else if (confirmPassword !== password) {
                    setError("Password and Confirm Password doesn't match.");
                }
            else {
                setError("");
                setIsLoading(true);
                const errormsg=await registerWithEmailAndPassword(name,email,password);
                setIsLoading(false);
                if(errormsg=="success")setShowModal(true);
                else setError(errormsg);
            }   
        }
        var modalContent;
        if(showModal)modalContent=<Modal setStep={props.setStep}></Modal>;
        const Registercontent=()=>{return(<div>
            <div >
               {modalContent}
	        </div>     
            <div className="register__content">
        <div className="left-content" id="left-content">
            <div className="top-part">
                <h2>Let's Reconnect</h2>
                <p>Alumni Association</p>
            </div>
            <div className="middle-content">
                
            </div>
            <div className="bottom-part">
                <h2>VIT AP</h2>
                <p>A professional platform to connect, share and recreate wonderful memories with distinguished Alumni.</p>
            </div>
            
        </div>
        <div className="right-content">
            
            <div className="middle-content">
                <h3>Register Here</h3>
                <div className='register_form_error'>{error}</div>
                <div className="form">
                    <form id="register_form" onSubmit={handleSubmit}>
                        {/* <div className="form-group">
                            <input type="text" placeholder="Name" value={name} onChange={(e)=>setName(e.target.value)} required/>
                        </div> */}
                        <div className="form-group">
                          <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} aria-describedby="emailHelp" placeholder="Enter email" required/>
                        </div>
                        <div className="form-group">
                            <input type={typee} placeholder="Password" value={password} onChange={(e)=>setPassword(e.target.value)} required />
                            {/* <i className="bi bi-eye-slash" id="togglePassword"></i> */}
                            <span onClick={handleTogglee}><Icon icon={iconn} size={15}/></span>
                        </div>
                        <div className="form-group">
                            <input type={type} placeholder="Confirm Password" value={confirmPassword} onChange={(e)=>setConfirmPassword(e.target.value)} required />
                            {/* <i className="bi bi-eye-slash" id="togglePassword"></i> */}
                            <span onClick={handleToggle}><Icon icon={icon} size={15}/></span>
                        </div>

                       
                        <button type="submit" className="submit btn btn-primary">Submit</button>
                      </form>
                    <p>Already have an account? <Link aria-current="page" to="/login">Login Here</Link></p>
                </div>
            </div>
            
        </div>
    </div>
        </div>)};
    return (
        <React.Fragment>
            
        <Header></Header>
            {isLoading?<LoadingScreen></LoadingScreen>:Registercontent()}
           
        <ConnectWithUs></ConnectWithUs>
        <Footer></Footer>
        </React.Fragment>
    );
}
export default Register;